import { AlertScale } from './domain/AlertScale';
import type { EvaluationRule, EvaluationRules } from './evaluation/EvaluationRule';

export function createDefaultEvaluationRules(): EvaluationRules {
  const rules: EvaluationRule[] = [
    {
      calculationProperty: 'Lv_Phase1Min',
      value: AlertScale.fromWarningVectors([1000, 1000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Lv_Phase1Max',
      value: AlertScale.fromWarningVectors([1000, 1000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Lv_Phase2Min',
      value: AlertScale.fromWarningVectors([1000, 1000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Lv_Phase3Max',
      value: AlertScale.fromWarningVectors([1000, 1000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Mv_Phase1Min',
      value: AlertScale.fromWarningVectors([1000, 10000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Mv_Phase1Max',
      value: AlertScale.fromWarningVectors([1000, 10000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Mv_Phase2Min',
      value: AlertScale.fromWarningVectors([1000, 10000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Mv_Phase3Max',
      value: AlertScale.fromWarningVectors([1000, 10000], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Lv_PowerTransformer_AvailableCapacity',
      value: AlertScale.fromWarningVectors([0, 0], [Infinity, Infinity])
    },
    {
      calculationProperty: 'Lv_PowerTransformer_LoadingPercent',
      value: AlertScale.fromWarningVectors([-Infinity, -Infinity], [100, 100])
    },
    {
      calculationProperty: 'Lv_AcLineSegment_LoadingPercent',
      value: AlertScale.fromWarningVectors([0, 0], [80, 100])
    },
    {
      calculationProperty: 'Lv_EnergyConsumer_VoltageDiffTransformerEndPercent',
      value: AlertScale.fromWarningVectors([-8, -8], [8, 8])
    },
    {
      calculationProperty: 'Mv_PowerTransformer_LoadingPercent',
      value: AlertScale.fromWarningVectors([0, 0], [80, 100])
    },
    {
      calculationProperty: 'Mv_AcLineSegment_LoadingPercent',
      value: AlertScale.fromWarningVectors([0, 0], [80, 100])
    },
    {
      calculationProperty: 'Mv_Busbar_VoltageDiffTransformerEndPercent',
      value: AlertScale.fromWarningVectors([-10, -5], [5, 10])
    },
    {
      calculationProperty: 'Mv_EnergyConsumer_VoltageDiffTransformerEndPercent',
      value: AlertScale.fromWarningVectors([-10, -5], [5, 10])
    }
  ];
  return {
    type: 'AVAILABLE',
    rules
  };
}
